export default __webpack_public_path__ + "static/media/Create-documentation.d4d56675.md";